type PageNavigatorProps = {
    activeBox: string;
};

export enum PageNumber {
    ONE = 'ONE',
    TWO = 'TWO',
}

export const PageNavigator = ({ activeBox }: PageNavigatorProps) => {
    const circles = [
        { cx: 5, isActive: activeBox === PageNumber.ONE },
        { cx: 23, isActive: activeBox === PageNumber.TWO },
    ];

    return (
        <svg width="28" height="10" viewBox="0 0 28 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <title>Dot</title>
            {circles.map((circle) => (
                <circle key={circle.cx} cx={circle.cx} cy="5" r="5" fill={circle.isActive ? '#0063FB' : '#DEDEE3'} />
            ))}
        </svg>
    );
};
